import { useUIColors } from '@/core/hooks';
import PencilSvg from '@assets/images/svg/pencil.svg';
import React from 'react';
import { View } from 'react-native';

export interface PencilIconProps {
  size?: number;
  color?: string;
}

export const PencilIcon = React.memo<PencilIconProps>(function PencilIcon({
  size = 24,
  color,
}) {
  const colors = useUIColors();
  const stroke = color || colors.vectorsIconGreyscale;

  return (
    <View style={{ width: size, height: size, alignItems: 'center', justifyContent: 'center' }}>
      <PencilSvg width={size} height={size} color={stroke} stroke={stroke} fill="none" />
    </View>
  );
});

export default PencilIcon;